module.exports = __webpack_public_path__ + "media/images/social/facebook-f-brands-6c8c4cc72866164a134894cc6f690bfb.svg";